import React, { useState, useRef } from "react";
import classes from "./Dashboard.module.css";
import Header from "../../Components/Header/Header";
import Sidebar from "../../Components/Sidebar/Sidebar";
import { useNavigate } from "react-router-dom";
// Icons
import { 
  Sun, 
  Sunrise, 
  Sunset, 
  TrendingUp, 
  CheckCircle2, 
  AlertTriangle, 
  // Clock, 
  Layers, 
  Calendar as CalendarIcon, 
  MoreVertical 
} from "lucide-react";

import ReconciliationOverview from "../../Components/ReconciliationOverview/ReconciliationOverview";
import ReconciliationByAccount from "../../Components/ReconciliationByAccount/ReconciliationByAccount";
import Exceptions from "../../Components/Exceptions/Exceptions";
import ReconciliationTrend from "../../Components/ReconciliationTrend/ReconciliationTrend";

const runsData = [
  {
    id: "RUN-08241",
    date: "01-14 Aug 2026",
    account: "GTBank Main Account",
    accountNumber: "GTB • 1234567890",
    transactions: "18,420 / 18,210",
    matchRate: "98.2%",
    matchPercent: 98.2,
    exceptions: "42",
    exceptionAmount: "₦840,000",
    status: "Completed",
    owner: "Adekunle O.",
    lastUpdated: "14 Aug, 2026",
    time: "10:31 AM",
    badgeType: "success"
  },
  {
    id: "RUN-08240",
    date: "01-14 Aug 2026",
    account: "Fidelity Account",
    accountNumber: "Fidelity • 1234567890",
    transactions: "12,840 / 12,680",
    matchRate: "96.4%",
    matchPercent: 96.4,
    exceptions: "86",
    exceptionAmount: "₦1,420,000",
    status: "In Progress",
    owner: "Agbakia E.",
    lastUpdated: "14 Aug, 2026",
    time: "09:47 AM",
    badgeType: "warning"
  },
];

const Dashboard = () => {
  const [selectedDate, setSelectedDate] = useState("2026-08-14");
  const dateInputRef = useRef(null);
const navigation = useNavigate();
  const getGreeting = () => {
    const hour = new Date().getHours();
    if (hour >= 0 && hour < 12) {
      return { text: "Good morning", icon: <Sunrise size={22} className={classes.greetingIconMorning} /> };
    }
    if (hour >= 12 && hour < 16) {
      return { text: "Good afternoon", icon: <Sun size={22} className={classes.greetingIconAfternoon} /> };
    }
    return { text: "Good evening", icon: <Sunset size={22} className={classes.greetingIconEvening} /> };
  };

  const greeting = getGreeting();

  return (
    <div className={classes.page}>
      <Header />
      <Sidebar />

      <main className={classes.main}>
        <div className={classes.container}>
          
          {/* Header Bar */}
          <div className={classes.topBar}>
            <div>
              <h1 className={classes.welcome}>
                {greeting.text}, Adekunle {greeting.icon}
              </h1>
              <p className={classes.subtext}>
                Here's what's happening with your reconciliations today.
              </p>
            </div>

            <div className={classes.datePickerWrapper} onClick={() => dateInputRef.current?.showPicker()}>
              <CalendarIcon size={18} className={classes.calendarIcon} />
              <input
                ref={dateInputRef}
                type="date"
                value={selectedDate}
                onChange={(e) => setSelectedDate(e.target.value)}
                className={classes.dateslct}
              />
            </div>
          </div>

          {/* Metric Cards Grid */}
          <div className={classes.metricsGrid}>
            <div className={classes.metricCard}>
              <div className={`${classes.iconBadge} ${classes.blueBadge}`}>
                <Layers size={20} />
              </div>
              <div className={classes.metricContent}>
                <span className={classes.metricTitle}>Total Transactions</span>
                <span className={classes.metricValue}>124,850</span>
                <div className={`${classes.metricChangeContainer} ${classes.positive}`}>
                  <TrendingUp size={14} />
                  <span>8.4% vs last period</span>
                </div>
              </div>
            </div>

            <div className={classes.metricCard}>
              <div className={`${classes.iconBadge} ${classes.greenBadge}`}>
                <CheckCircle2 size={20} />
              </div>
              <div className={classes.metricContent}>
                <span className={classes.metricTitle}>Reconciled</span>
                <span className={classes.metricValue}>118,420</span>
                <div className={`${classes.metricChangeContainer} ${classes.neutral}`}>
                  <span>94.8% of total</span>
                </div>
              </div>
            </div>

            <div className={classes.metricCard}>
              <div className={`${classes.iconBadge} ${classes.redBadge}`}>
                <AlertTriangle size={20} />
              </div>
              <div className={classes.metricContent}>
                <span className={classes.metricTitle}>Unmatched</span>
                <span className={classes.metricValue}>6,430</span>
                <div className={`${classes.metricChangeContainer} ${classes.subtle}`}>
                  <span>₦18.4M in value</span>
                </div>
              </div>
            </div>

            <div className={classes.metricCard}>
              <div className={`${classes.iconBadge} ${classes.orangeBadge}`}>
                <AlertTriangle size={20} />
              </div>
              <div className={classes.metricContent}>
                <span className={classes.metricTitle}>Open Exceptions</span>
                <span className={classes.metricValue}>824</span>
                <div className={`${classes.metricChangeContainer} ${classes.subtle}`}>
                  <span>₦8.6M in value</span>
                </div>
              </div>
            </div>

            {/* <div className={classes.metricCard}>
              <div className={`${classes.iconBadge} ${classes.purpleBadge}`}>
                <Clock size={20} />
              </div>
              <div className={classes.metricContent}>
                <span className={classes.metricTitle}>Pending Approval</span>
                <span className={classes.metricValue}>18</span>
                <div className={`${classes.metricChangeContainer} ${classes.subtle}`}>
                  <span>₦2.4M in value</span>
                </div>
              </div>
            </div> */}
          </div>

          {/* Core Analytics Section */}
          <div className={classes.grid}>
            <section className={classes.card}>
              <ReconciliationOverview />
            </section>
            <section className={classes.card}>
              <ReconciliationByAccount />
            </section>
          </div>

          {/* Secondary Analytics Section */}
          <div className={classes.twoColGrid}>
            <section className={classes.card}>
              <Exceptions />
            </section>
            <section className={classes.card}>
              <ReconciliationTrend />
            </section>
          </div>

          {/* Table Container */}
          <div className={classes.runsTableFrame}>
            <div className={classes.runsTopBar}>
              <div>
                <h3 className={classes.runsTitle}>Recent Reconciliation Runs</h3>
                <p className={classes.tableSubtext}>Monitor automated matching execution logs</p>
              </div>
              <button onClick={() => navigation('/Reconcilation')} type="button" className={classes.runsViewAll}>View all runs</button>
            </div>

            <div className={classes.runsTableWrap}>
              <table className={classes.runsTable}>
                <thead>
                  <tr>
                    <th>S/N</th>
                    <th>Account Info</th>
                    <th>Bank / Ledger</th>
                    <th>Match Rate</th>
                    <th>Exceptions</th>
                    {/* <th>Status / Owner</th> */}
                    <th>Updated</th>
                    {/* <th style={{ textAlign: "center" }}>Actions</th> */}
                  </tr>
                </thead>
                <tbody>
                  {runsData.map((run, idx) => (
                    <tr key={run.id}>
                      <td>{idx + 1}</td>
                      <td>
                        <div className={classes.runsAccountName}>{run.account}</div>
                        <div className={classes.runsAccountNumber}>{run.accountNumber}</div>
                      </td>
                      <td>
                        <div className={classes.runsTransactions}>{run.transactions}</div>
                      </td>
                      <td>
                        <div className={classes.matchRateHeader}>
                          <span className={classes.runsMatchRate}>{run.matchRate}</span>
                        </div>
                        <div className={classes.runsMatchBar}>
                          <div
                            className={classes.runsMatchBarFill}
                            style={{ width: `${run.matchPercent}%` }}
                          />
                        </div>
                      </td>
                      <td>
                        <div className={classes.runsExceptionCount}>{run.exceptions}</div>
                        <div className={classes.runsExceptionAmount}>{run.exceptionAmount}</div>
                      </td>
                      {/* <td>
                        <span className={`${classes.statusBadge} ${classes[run.badgeType]}`}>
                          <span className={classes.statusDot} />
                          {run.status}
                        </span>
                        <div className={classes.runsOwner}>{run.owner}</div>
                      </td> */}
                      <td>
                        <div className={classes.runsUpdatedDate}>{run.lastUpdated}</div>
                        <div className={classes.runsUpdatedTime}>{run.time}</div>
                      </td>
                      {/* <td style={{ textAlign: "center" }}>
                        <button type="button" className={classes.runsActionButton} aria-label="More actions">
                          <MoreVertical size={16} />
                        </button>
                      </td> */}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

        </div>
      </main>
    </div>
  );
};

export default Dashboard;